import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Logos } from "../assets/logos";

export default function Register() {
  const navigate = useNavigate();

  const { register } = useAuth();

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [message, setMessage] = useState("");

  /* ================================================= */
  /* Email Validation                                  */
  /* ================================================= */

  const isValidEmail = (value) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  };

  /* ================================================= */
  /* Handle Register                                   */
  /* ================================================= */

  const handleRegister = async () => {
    if (!name.trim()) {
      setError("Please enter your name");
      return;
    }

    if (!isValidEmail(email)) {
      setError("Please enter a valid email address");
      return;
    }

    setLoading(true);
    setError("");
    setMessage("");

    try {
          await register({
            name: name.trim(),
            email: email.trim(),
          });
      setMessage("Registration successful! Redirecting to login...");

      setTimeout(() => {
        navigate("/login");
      }, 1500);

    } catch (err) {
      setError(err.message || "Registration failed");
    } finally {
      setLoading(false);
    }
  };

  /* ================================================= */
  /* UI                                                */
  /* ================================================= */

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center items-center px-4">

      {/* Logo */}

      <div className="mb-8 flex flex-col items-center">

        <img
          src={Logos.original.rectangle}
          alt="HeadwaySpot"
          className="h-12 sm:h-14 mb-3"
        />

        <h2 className="text-xl font-semibold text-gray-700 tracking-wide">
          Create your HeadwaySpot account
        </h2>

      </div>

      {/* Card */}

      <div className="w-full max-w-md rounded-2xl border border-gray-200 bg-white p-6 shadow-md">

        <h3 className="text-lg font-medium text-center mb-6">
          Let’s get started 🚀
        </h3>

        <div className="space-y-4">

          {/* Full Name */}

          <div>
            <label className="block text-sm text-gray-600 mb-1">
              Full Name
            </label>

            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Your name"
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring focus:ring-gray-200 outline-none"
            />
          </div>

          {/* Email */}

          <div>
            <label className="block text-sm text-gray-600 mb-1">
              Email
            </label>

            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@company.com"
              className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm focus:ring focus:ring-gray-200 outline-none"
            />
          </div>

          {/* Error */}

          {error && (
            <div className="rounded-lg border border-rose-200 bg-rose-50 p-2 text-xs text-rose-700">
              {error}
            </div>
          )}

          {/* Success */}

          {message && (
            <div className="rounded-lg border border-emerald-200 bg-emerald-50 p-2 text-xs text-emerald-700">
              {message}
            </div>
          )}

          {/* Submit */}

          <button
            onClick={handleRegister}
            disabled={loading}
            className="w-full bg-gray-900 text-white py-2 rounded-lg text-sm hover:opacity-90 disabled:opacity-50"
          >
            {loading ? "Registering…" : "Register"}
          </button>

        </div>

        {/* Divider */}

        <div className="flex items-center my-6">

          <div className="flex-1 h-px bg-gray-200" />

          <span className="px-3 text-xs text-gray-400">
            or
          </span>

          <div className="flex-1 h-px bg-gray-200" />

        </div>

        {/* Login */}

        <p className="text-sm text-center text-gray-600">
          Already have an account?{" "}
          <Link
            to="/login"
            className="text-orange-600 hover:underline"
          >
            Sign in
          </Link>
        </p>

      </div>

      {/* Footer */}

      <p className="mt-8 text-xs text-gray-400 text-center">
        © {new Date().getFullYear()} Funde Technologies
      </p>

    </div>
  );
}